<template>
  <form>
    <b-modal
      v-model="show"
      :title="title"
      modal-class="spso-modal"
      hide-header-close
      hide-footer
      centered
      size="lg"
      @hide="hideModal"
    >
      <div class="v-application spso-modal__body pt-4 break-word">
        <locale-error-table
          v-if="errorList"
          class="locale-errors-table"
          :error-list="errorList"
        />
        <div
          v-else
          class="d-flex py-4"
        >
          <span class="mx-auto">{{ $t('common.no_data') }}</span>
        </div>
      </div>
      <div class="v-application d-flex mt-4 sticky-bottom">
        <v-btn
          color="primary"
          class="mr-4 flex-grow-1"
          outlined
          large
          @click="hideModal"
        >
          {{ $t('common.close') }}
        </v-btn>
      </div>
    </b-modal>
  </form>
</template>

<script>
import 'vue-json-pretty/lib/styles.css';
import { mapState } from 'vuex';
import LocaleErrorTable from '@/components/common/LocaleErrorTable.vue';

export default {
  name: 'ShippingErrorsModal',
  components: {
    LocaleErrorTable,
  },
  props: {
    title: String,
    value: Boolean,
    message: String,
    errorList: Array,
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    ...mapState({
      user: 'user',
    }),
  },
  watch: {
    value(val) {
      this.show = val;
    },
  },
  methods: {
    hideModal() {
      this.$emit('input', false);
    },
  },
};
</script>

<style lang="scss">
.break-word {
  overflow-wrap: break-word;
}

.locale-errors-table {
  max-height: 50vh;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: #fff;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--amber);
    border-radius: 10px;
  }
}
</style>
